import React from 'react';
import { AddProductForm } from '@travelity/api';
import { Box, Stack } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useLocation } from 'react-router-dom';
import Stepper from '../../components/stepper/stepper';
import StepperProvider from '../../components/stepper/stepper.provider';
import HelperProvider from '../../contexts/helper-context/helper-provider';
import { useUserContext } from '../../contexts/user';

import Steps from './components/steps';

const steps = [
    {
        label: 'Product Configuration',
        value: 'configuration',
    },
    {
        label: 'Product Details',
        value: 'product-details',
    },
    {
        label: 'Route',
        value: 'route',
    },
    {
        label: 'Capacity',
        value: 'capacity',
    },
    {
        label: 'Schedule',
        value: 'schedule',
    },
    {
        label: 'Pricing and Financials',
        value: 'financial-information',
    },
    {
        label: 'Product Options',
        value: 'product-options',
    },
    {
        label: 'Preview',
        value: 'preview',
    },
];

function AddProduct() {
    const location = useLocation();
    const { user } = useUserContext();

    return (
        <StepperProvider<Partial<AddProductForm>>
            steps={steps}
            defaultState={
                location.state || {
                    schedule: { timeZone: user?.timeZone },
                    financial: { currency: user?.currency },
                }
            }
        >
            <HelperProvider>
                <Stack
                    direction="row"
                    sx={{ height: 1 }}
                    spacing={1}
                    p={{ xs: 0, md: 2 }}
                >
                    <Box
                        sx={{
                            flexGrow: 1,
                            bgcolor: '#FFFFFF',
                            p: { xs: 1, md: 3 },
                            pr: { xs: 0, md: 2 },
                            pl: { xs: 2, md: 3 },
                            overflow: 'auto',
                            position: 'relative',
                        }}
                    >
                        <Steps />
                    </Box>
                    <Box
                        sx={{
                            display: { xs: 'none', sm: 'block' },
                            p: 0.5,
                            flexShrink: 0,
                            width: 260,
                            bgcolor: '#FFFFFF',
                            overflow: 'auto',
                        }}
                    >
                        <PerfectScrollbar>
                            <Stepper />
                        </PerfectScrollbar>
                    </Box>
                </Stack>
            </HelperProvider>
        </StepperProvider>
    );
}

export default AddProduct;
